import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "../lib/api";
import { toast } from "sonner";
import LionLogo from "../components/LionLogo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("ldp_token", data.token);
      localStorage.setItem("ldp_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center">
          <LionLogo size={72} className="mx-auto" />
          <h1 className="font-serif text-3xl mt-6">Admin Sign In</h1>
          <div className="overline mt-2 text-[#D4AF37]">Lyon's Den Protection</div>
        </div>
        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="overline block mb-3">Email</label>
            <input type="email" required value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} className="w-full bg-transparent border-b border-white/20 py-3 focus:border-[#D4AF37] outline-none" data-testid="admin-login-email" />
          </div>
          <div>
            <label className="overline block mb-3">Password</label>
            <input type="password" required value={form.password} onChange={(e)=>setForm({...form, password:e.target.value})} className="w-full bg-transparent border-b border-white/20 py-3 focus:border-[#D4AF37] outline-none" data-testid="admin-login-password" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-[#8B0000] hover:bg-[#A50000] text-white px-8 py-4 text-xs uppercase tracking-[0.2em]" data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
